import { getVerifyAccountCTA } from "./shared";
export var ProvideRequestedInfoIA = function ProvideRequestedInfoIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getVerifyAccountCTA;
        return (_getVerifyAccountCTA = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA === void 0 ? void 0 : _getVerifyAccountCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getVerifyAccountCTA2, _getVerifyAccountCTA3;
        return (_getVerifyAccountCTA2 = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA2 === void 0 ? void 0 : (_getVerifyAccountCTA3 = _getVerifyAccountCTA2.getLink) === null || _getVerifyAccountCTA3 === void 0 ? void 0 : _getVerifyAccountCTA3.call(_getVerifyAccountCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_HAVE_NOT_SUBMITTED(strictLocalize), IF_YOU_HAVE_ALREADY_SUBMITTED(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "zHlNDl",
    defaultMessage: [{
      "type": 0,
      "value": "Fournissez des informations pour vérifier votre compte"
    }]
  });
};
var IF_YOU_HAVE_NOT_SUBMITTED = function IF_YOU_HAVE_NOT_SUBMITTED(strictLocalize) {
  return strictLocalize({
    id: "V8CNC/",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous n'avez pas encore envoyé le formulaire de vérification de compte, veuillez y indiquer toutes les informations requises."
    }]
  });
};
var IF_YOU_HAVE_ALREADY_SUBMITTED = function IF_YOU_HAVE_ALREADY_SUBMITTED(strictLocalize) {
  return strictLocalize({
    id: "GHShML",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez déjà envoyé le formulaire, vous recevrez un e-mail dès que nous aurons examiné vos informations. Nous répondons généralement dans un délai d'un jour ouvré."
    }]
  });
};